import React, { Dispatch, SetStateAction} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

interface switchOverProps{
  showModal : boolean
  setShowModal : Dispatch<SetStateAction<boolean>> 
  switchParticipant : () => void
}

export default function participantSwitchOverModal({showModal, setShowModal, switchParticipant} : switchOverProps) {

  const handleClose = () => {
    setShowModal(true);
  };

  const handleSwitchOver = () => {
    handleClose()
    switchParticipant()
  }
  
  return (
      <Dialog
        open={showModal}
        onClose={handleClose}
        disableEscapeKeyDown
        disableBackdropClick
        fullWidth = {true}
        maxWidth = 'xs'
      >
        <DialogTitle>Switch over participant Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText> Are you sure want to switch over participant? Current sketches
            may be lost. </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleSwitchOver}>
            Switch Over
          </Button>
          <Button variant="contained" color="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
  );
}